import React from 'react';

import { GridRow } from '../../layout/Grid/GridRow';
import { GridColumn } from '../../layout/Grid/GridColumn';
import { Layout } from '../../layout/Layout/Layout';
import { LayoutItem } from '../../layout/Layout/LayoutItem';
import { Gutter } from '../../layout/Gutter/Gutter';
import { CondensedSmall } from '../../content/CondensedSmall/CondensedSmall';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

import type { FocusAreaBarsFocusAreaType } from './focus-area-bars.types';
import { FocusAreaBarsProgress } from './FocusAreaBarsProgress';

export type FocusAreaBarsRowProps = {
  name?: string;
  focusArea: FocusAreaBarsFocusAreaType;
  condensed?: boolean;
};

export const FocusAreaBarsRow = ({
  name = 'FOCUS_AREA_BARS_ROW',
  focusArea,
  condensed = false,
}: FocusAreaBarsRowProps) => {
  const { isSmallScreen } = useBreakpoint();

  const formatYears = (years: number) => {
    if (years >= 10) {
      return '10+ yrs';
    }

    return years < 1 ? '<1 yrs' : `${Math.round(years)} yrs`;
  };

  return (
    <GridRow
      name={name}
      gutterVertical="4px"
      className={condensed ? 'focus-area-bars-row-condensed' : undefined}
    >
      {isSmallScreen || condensed ? (
        <>
          <GridColumn width={12}>
            <FocusAreaBarsProgress focusArea={focusArea} />
          </GridColumn>
          <GridColumn width={12}>
            <Gutter top="4px">
              <Layout position="space-between middle">
                <LayoutItem hug>
                  <CondensedSmall name="FOCUS_AREA_NAME">
                    {focusArea.name}
                  </CondensedSmall>
                </LayoutItem>
                <LayoutItem position="right">
                  <Gutter left="16px">
                    <CondensedSmall name="FOCUS_AREA_YEARS_OF_EXPERIENCE">
                      {formatYears(focusArea.yearsOfExperience)}
                    </CondensedSmall>
                  </Gutter>
                </LayoutItem>
              </Layout>
            </Gutter>
          </GridColumn>
        </>
      ) : (
        <>
          <GridColumn width={3}>
            <Layout position="middle left" stretched>
              <LayoutItem>
                <CondensedSmall name="FOCUS_AREA_NAME">
                  {focusArea.name}
                </CondensedSmall>
              </LayoutItem>
            </Layout>
          </GridColumn>
          <GridColumn width={8}>
            <Layout position="middle left" stretched>
              <LayoutItem hug>
                <FocusAreaBarsProgress focusArea={focusArea} />
              </LayoutItem>
            </Layout>
          </GridColumn>
          <GridColumn width={1}>
            <Layout position="middle right" stretched>
              <CondensedSmall name="FOCUS_AREA_YEARS_OF_EXPERIENCE">
                {formatYears(focusArea.yearsOfExperience)}
              </CondensedSmall>
            </Layout>
          </GridColumn>
        </>
      )}
    </GridRow>
  );
};
